<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-snackbar
      v-model="snackbar"
      xs12
      multi-line
      :timeout="timeout"
      top
      color="orange"
    >
      {{ alertmessage }}
      <v-btn
        color="white"
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <v-row>
      <v-col>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          color="primary"
        />
      </v-col>
    </v-row>
    <sequential-entrance from-top>
      <v-row>
        <v-col
          sm="12"
          md="12"
          lg="12"
        >
          <base-material-card
            color="primary"
            icon="mdi-wrench"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                Cash Connect Configuration
              </div>
            </template>
            <v-data-table
              :headers="headers"
              :items="getccSites"
              :search="search"
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                >
                  <v-toolbar-title>Cash Connect Enabled Sites</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  />
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  />
                  <v-spacer />
                  <v-dialog
                    v-model="dialog"
                    max-width="500px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        class="mb-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        New Config
                      </v-btn>
                      <download-csv
                        :name="csvfilename()"
                        :data="ccsites"
                      >
                        <v-btn color="info">
                          <v-icon
                            color="white"
                            left
                          >
                            mdi-arrow-down
                          </v-icon><span class="white--text">CSV</span>
                        </v-btn>
                      </download-csv>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-autocomplete
                                v-if="!editingSite"
                                v-model="currentsite"
                                :autocomplete="Date.now()"
                                :items="allsites"
                                item-text="idnum"
                                return-object
                                color="secondary"
                                label="Select Site - only shows sites with safes"
                                validate-on-blur
                                @change="onChange($event)"
                              />
                            </v-col>
                            <v-col v-if="editingSite">
                              <v-text-field
                                v-model="editedItem.idnum"
                                outlined
                                readonly
                                label="Site Name"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="editedItem.safeid"
                                outlined
                                readonly
                                label="Safe ID"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-menu
                                ref="menu"
                                v-model="editedItem.golive"
                                :close-on-content-click="false"
                                :return-value.sync="date"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="date"
                                    outlined
                                    label="Go Live"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                  />
                                </template>
                                <v-date-picker
                                  v-model="date"
                                  no-title
                                  scrollable
                                >
                                  <v-spacer />
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="menu = false"
                                  >
                                    Cancel
                                  </v-btn>
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.menu.save(date)"
                                  >
                                    OK
                                  </v-btn>
                                </v-date-picker>
                              </v-menu>
                            </v-col>

                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-menu
                                ref="menupickup"
                                v-model="editedItem.firstpickup"
                                :close-on-content-click="false"
                                :return-value.sync="datepickup"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="datepickup"
                                    outlined
                                    label="First Pickup"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                  />
                                </template>
                                <v-date-picker
                                  v-model="datepickup"
                                  no-title
                                  scrollable
                                >
                                  <v-spacer />
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="menupickup = false"
                                  >
                                    Cancel
                                  </v-btn>
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.menupickup.save(datepickup)"
                                  >
                                    OK
                                  </v-btn>
                                </v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-select
                                v-model="editedItem.schedule"
                                :items="schedules"
                                outlined
                                label="Schedule"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="editedItem.ccid"
                                outlined
                                readonly
                                label="Cash Connect ID (default)"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="editedItem.override"
                                outlined
                                label="Over Ride Cash Connect ID"
                                :rules="overrideccidrules"
                              />
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="close"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          color="blue darken-1"
                          :disabled="!formIsValid"
                          text
                          @click="save"
                        >
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-dialog
                    v-model="dialogDelete"
                    max-width="600px"
                  >
                    <v-card>
                      <v-card-title class="headline">
                        Are you sure you want to delete this item?
                      </v-card-title>
                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="closeDelete"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="deleteItemConfirm"
                        >
                          OK
                        </v-btn>
                        <v-spacer />
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:[`item.timestamp`]="{ item }">
                {{ format_time(item.timestamp) }}
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="editItem(item)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  small
                  @click="deleteItem(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
              <template v-slot:no-data>
                <v-btn
                  color="primary"
                  @click="initialize"
                >
                  Reset
                </v-btn>
              </template>
            </v-data-table>
          </base-material-card>
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'

  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      menupickup: false,
      menu: false,
      datepickup: '',
      date: '',
      timeout: 5000,
      snackbar: false,
      alertmessage: '',
      search: '',
      unique: true,
      filterchars: true,
      onlyspace: false,
      allowSpaces: false,
      max: 22,
      headers: [
        {
          text: 'SiteName',
          align: 'start',
          sortable: true,
          value: 'idnum',
        },
        {
          text: 'Last Edit',
          align: 'center',
          sortable: true,
          value: 'timestamp',
          width: 10
        },
        {
          text: 'Safe ID',
          align: 'center',
          sortable: true,
          value: 'safeid',
        },
        {
          text: 'Go Live',
          align: 'center',
          sortable: true,
          value: 'golive',
          width: 10
        },
        {
          text: 'Schedule',
          align: 'center',
          sortable: true,
          value: 'schedule',
        },
        {
          text: 'First Pickup',
          align: 'center',
          sortable: true,
          value: 'firstpickup',
        },
        {
          text: 'CC ID',
          align: 'center',
          sortable: true,
          value: 'ccid',
        },
        {
          text: 'Over Ride ID',
          align: 'center',
          sortable: true,
          value: 'override',
        },
        { text: 'Actions', value: 'actions', align: 'center', sortable: false },
      ],
      schedules: ['daily', 'weekly', 'biweekly', 'monthly'],
      ccsites: [],
      currentsite: '',
      editedIndex: -1,
      editedItem: {
        idnum: '',
        sitekey: '',
        key: '',
        ccid: '',
        safeid: '',
        override: '',
        timestamp: '',
        golive: '',
        schedule: '',
        firstpickup: ''
      },
      defaultItem: {
        idnum: '',
        sitekey: '',
        ccid: '',
        key: '',
        safeid: '',
        override: '',
        timestamp: '',
        golive: '',
        schedule: '',
        firstpickup: ''
      },
    }),

    computed: {
      formIsValid () {
        return this.editedItem.idnum !== '' &&
          this.editedItem.ccid !== '' &&
          this.editedItem.safeid !== ''
      },
      ccidrules () {
        const rules = []
        if (this.unique) {
          // if current site name is not the value
          console.log('adding unique rule')
          const rule =
            v => (!this.ccsites.map(entry => entry.ccid).includes(v)) ||
              'Sites can only appear once in the list'

          rules.push(rule)
        }
        if (this.max) {
          const rule =
            v => (v || '').length <= this.max ||
              `A maximum of ${this.max} characters is allowed in a site name`

          rules.push(rule)
        }

        if (!this.allowSpaces) {
          const rule =
            v => (v || '').indexOf(' ') < 0 ||
              'No spaces are allowed'

          rules.push(rule)
        }
        if (this.filterchars) {
          const rule =
            v => !v.match(/\\t|[#\$\[\]\.]/gi) || ' $ # [ ] tabs are not allowed in a cash connect ID'
          rules.push(rule)
        }
        return rules
      },
      overrideccidrules () {
        const rules = []
        if (this.unique) {
          // if current site name is not the value
          console.log('adding unique rule')
          const rule =
            v => (!this.ccsites.map(entry => entry.override).includes(v)) ||
              'Sites can only appear once in the over ride list'

          rules.push(rule)
        }
        if (this.max) {
          const rule =
            v => (v || '').length <= this.max ||
              `A maximum of ${this.max} characters is allowed in a site name`

          rules.push(rule)
        }

        if (!this.allowSpaces) {
          const rule =
            v => (v || '').indexOf(' ') < 0 ||
              'No spaces are allowed'

          rules.push(rule)
        }
        if (this.filterchars) {
          const rule =
            v => !v.match(/\\t|[#\$\[\]\.]/gi) || ' $ # [ ] tabs are not allowed in a cash connect ID'
          rules.push(rule)
        }
        return rules
      },
      allsites () {
        let sites = []
        // get only sites with a safe assigned to it
        let uniquesites = [...new Set(this.$store.getters.loadedSites)]
        uniquesites.forEach(entry => {
          let ccsiteidnums = this.ccsites.map(entry => entry.idnum)
          if (!ccsiteidnums.includes(entry.idnum)) {
            let loadedprofiles = this.$store.getters.loadedSiteProfiles
            let siteprofile = loadedprofiles[entry.idnum]
            if (siteprofile) {
              if (siteprofile.siteunitsprofile && siteprofile.siteunitsprofile[0]) {
                console.log(siteprofile)
                sites.push(entry)
              }
            }
          }
        })
        // dont give them the option to add a site which is already present

        return sites
      },
      formTitle () {
        return this.editedIndex === -1 ? 'New Config' : 'Edit Config'
      },
      editingSite () {
        return this.editedIndex !== -1
      },
      loading () {
        // return true
        return this.$store.getters.getloading
      },
      getccSites () {
        this.ccsites = []
        this.ccsites = this.$store.getters.getCashConnectSites
        console.log('loaded cc sites from view ', this.ccsites)
        return this.ccsites
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.ccsites = []
      this.$store.dispatch('loadccSites')
      this.$store.dispatch('loadunits')
      this.$store.dispatch('loadsiteProfiles')
      this.$store.dispatch('loadSiteConfigs')
      this.initialize()
    },

    methods: {
      format_time (ts) {
        return moment(ts).format('YYYY-MM-DD, HH:mm:ss')
      },
      csvfilename () {
        let today = moment().format('YYYY-MM-DD')
        let filename = today + '_ccfile' + '.csv'
        this.$log.debug('file name ', filename)
        return filename
      },
      onChange (value) {
        this.siteunitsprofile = []
        this.loadedprofiles = this.$store.getters.loadedSiteProfiles
        let site = this.$store.getters.loadedSites.filter(function (site) {
          return site.idnum === value.idnum
        })
        this.sitedetails = site[0]
        let idnum = this.sitedetails.idnum
        // lets find that sites profile from the ones we loaded and show the tokens they want to offer clients to buy and sell
        if (this.loadedprofiles[idnum].siteunitsprofile) {
          this.siteunitsprofile = this.loadedprofiles[idnum].siteunitsprofile
        }
        console.log('found this detail ', this.siteunitsprofile)
        let safeid = ''
        if (this.siteunitsprofile[0] && this.siteunitsprofile[0].crypto_idnum) {
          safeid = this.siteunitsprofile[0].crypto_idnum
        }
        this.editedItem.safeid = safeid
        let id = ''
        let ccidname = ''
        id = safeid.split('-')[1]
        let MAXCCLIMIT = 15
        ccidname = id.slice(0, MAXCCLIMIT) // slice 1 char off the end
        this.editedItem.ccid = ccidname
        this.editedItem.idnum = value.idnum
        console.log('######  ', this.editedItem.idnum, value)
        this.editedItem.sitekey = value.sitekey
      },
      initialize () {
        this.ccsites = this.$store.getters.getccSites
      },

      editItem (item) {
        console.log('item to edit ', item)
        let site = this.$store.getters.loadedSites.filter(site => {
          return site.idnum === item.idnum
        })
        this.currentsite = site
        console.log('current ', this.currentsite, site)
        this.editedIndex = this.ccsites.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.ccsites.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.ccsites.splice(this.editedIndex, 1)
        this.$store.dispatch('removeccSite', this.editedItem)
        this.$store.dispatch('loadccSites')
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.currentsite = ''
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (this.editedItem.ccid) {
          // check to see its unique
          console.log('current ccsites ', this.ccsites)
          let allccid = this.ccsites.map(entry => entry.ccid)

          let allover_ride = this.ccsites.map(entry => entry.override)
          console.log('check ', allccid, this.editedItem.ccid)
          console.log('check ', allover_ride, ' over ride ', this.editedItem.override)
          // it being blank is allowed

          if (this.editedItem.override !== '') {
            if (allover_ride.includes(this.editedItem.override)) {
              console.log('THERE CAN BE ONLY ONE')
              this.alertmessage = 'Over Ride ID must be unique'
              this.snackbar = true
              this.close()
              return
            }
          }
          if (this.editedItem.ccid !== '') {
            if (allccid.includes(this.editedItem.ccid)) {
              console.log('THERE CAN BE ONLY ONE')
              this.alertmessage = 'Cash Connect ID must be unique'
              this.snackbar = true
              this.close()
              return
            }
          }
        }
        if (this.editedIndex > -1) {
          Object.assign(this.ccsites[this.editedIndex], this.editedItem)
          this.$store.dispatch('updateccSite', this.editedItem)
        } else {
          console.log('editedItem ', this.editedItem)
          if (!this.ccsites) {
            this.ccsites = []
            console.log('ccsites init ', this.ccsites)
          }
          this.ccsites.push(this.editedItem)
          this.$store.dispatch('createccSite', this.editedItem)
        }
        this.$store.dispatch('loadccSites')
        this.close()
      },
    },
  }
</script>
